import React from 'react';
import PropTypes from 'prop-types';
import { commitMutation, graphql } from 'react-relay';
import { GlobalNotifications, Intent } from '../../Modules';
import Share from '../Sections/Actions/Share';

export default class EstimateShare extends React.Component {
  static propTypes = {
    document: PropTypes.object.isRequired,
    trigger: PropTypes.node.isRequired,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    relay: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.sendEmail = this.sendEmail.bind(this);
  }

  sendEmail(formModel, successCb) {
    const { subject, to, message } = formModel;
    const cc = formModel.cc === '' ? null : formModel.cc;
    const onCompleted = () => {
      successCb();
    };
    const onError = () => {
      GlobalNotifications.show({
        message: 'Unable to send email',
        intent: Intent.DANGER
      });
    };

    const mutation = graphql`
      mutation Share_emailEstimateLinkMutation($input: EmailEstimateLinkInput!) {
        emailEstimateLink(input: $input) {
          sent_email_to
          sent_email_cc
        }
      }
    `;

    const environment = this.props.relay.environment;

    commitMutation(environment, {
      mutation,
      variables: {
        input: { estimate_id: this.props.document.id, to, cc, subject, message }
      },
      onCompleted,
      onError
    });
  }

  render() {
    const {
      trigger,
      onOpen,
      onClose
    } = this.props;
    const permissionsNode = (
      <div>
        Anyone with the link <strong>can view</strong> this estimate.
      </div>
    );
    const workspaces = this.props.document.workspaces.edges;

    return (
      <Share
        document={this.props.document}
        canEmail={this.props.document.can_email}
        event={workspaces.length > 0 ? workspaces[0].node.event : null}
        title='Share Estimate'
        shareUrl={`${process.env.BASE_URL}/open/e/${this.props.document.share_token}`}
        documentType='estimate'
        permissionsNode={permissionsNode}
        sendEmail={this.sendEmail}
        trigger={trigger}
        onOpen={onOpen}
        onClose={onClose}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Document/Estimate/Share.js